import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';
import { getMeasurementBySize } from '../../../utils/icon';
import Icon from '../Icon/Icon';

export const IconRecipe = (props: IconType) => {
  const { size, inverse, onClick, width, height, iconClassName, stroke } =
    props;

  const defaultMeasurements: Measurements = {
    height: 24,
    width: 24,
  };

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon
      inverse={inverse}
      onClick={onClick}
      className={iconClassName}
      classNameIconType="c-icon-wifi"
    >
      <svg
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V8M20 22C18.8954 22 18 21.1046 18 20V8M20 22C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8H18M6 7H14M6 12H14M6 17H10"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
